














































































































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { ViewDataFromEmailApi } from '@/api'
import NotificationWithOutExit from "@/components/common/notification/NotificationWithOutExit.vue"

@Component({
    components: {
        'common-notification-notification': NotificationWithOutExit
    }
})
export default class EmailAlertSummaryTransfer extends Vue {
    loading: boolean = false
    
    isData:boolean = true
    username: string = ""
    email: string = ""
    transferDate: string = ""
    ReadDate: string = ""
    projectName: string = ""
    projectId: any = ""
    unitEmailTransferList: any[] = []
    unitEmailTransferOutList: any[] = []

    totalUnitAll = "0"
    totalUnitSold = "0"
    totalAllBooking = "0"
    totalAllContract = "0"
    totalRemainSoldUnit = "0"
    totalTransferUnit = "0"
    totalTransCashUnit = "0"
    totalTransferAtDepartmentOfLandsUnit = "0"
    totalRemainTransferUnit = "0"
    totalCurrentTransUnit = "0"
    unitTransferedList: any[] = []
    
    projectLists = [] as any

    async mounted() {
        await this.SetGetReportEmailTransfer()
    }

    async SetGetReportEmailTransfer() {
        try {
            this.isData = false
            this.loading = true
            const qs = this.$route.query
            const request = { projectId: qs.pid }
            const response = await ViewDataFromEmailApi.GetEmailAlertSummaryTransfer(request)
            this.projectId = request.projectId
            this.isData = true
    
            this.username = response.userName
            this.email = response.email
            this.transferDate = response.transferDate
            this.ReadDate = response.readDate
            this.projectName = `${response.projectCode} ${response.projectName}`
            this.totalUnitAll = response.allUnit
            this.totalUnitSold = response.soldUnit
            this.totalAllBooking = response.allBooking
            this.totalAllContract = response.allContract
            this.totalRemainSoldUnit = response.remainSoldUnit
            this.totalTransferUnit = response.transferUnit
            this.totalTransCashUnit = response.transCashUnit
            this.totalTransferAtDepartmentOfLandsUnit = response.transferAtDepartmentOfLandsUnit
            this.totalRemainTransferUnit = response.remainTransferUnit
            this.totalCurrentTransUnit = response.currentTransUnit
            this.unitTransferedList = response.unitTransferedList
            this.loading = false
        } catch (error) {
            this.notification('ไม่พบข้อมูล', 'warning') 
        }
    }

    isTransfer (transferType: string) {
        return transferType === 'โอน'
    }

    generateLink (data: any) {
        const date = new Date();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        let currentDate = `${--day}/${month}/${year}`;
        window.open(`/viewdata/unittransfered?pid=${this.projectId}&date=${data.endMonth}&headdate=${currentDate}`, '_blank');
    }

    monthTextTh (month: number) {
       const monthTextTh = ['', 'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
       return monthTextTh[month]
    }

    notification (text: string, status: string) {
        const child = this.$refs.refNotification as any
        child.openNotification(text, status)
    }
}
